<div class="row">  
  <span class="col-md-12 text-right boldlbl">Page 6 of 10</span>  
</div>
<ng-template #content let-modal>
    <div class="modal-body">
      <p>Please click on your business category and select your NAICS code.</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary">Cancel</button>
      <button type="button" class="btn btn-primary">Submit</button>
    </div>
  </ng-template>
<div class="row p-4">
    <div class="col-md-12">
        <h3 class="text-center">New Business Registration</h3>
        <h4 class="text-center">Application</h4>
    </div>
</div>
<h4>
    When registering your business be sure to be thorough and provide all necessary information to
    facilitate the registration of your business. Also include a telephone number and email address
    (see Filer section below) where we may contact you should any questions arise.
</h4>
<div>
    <br>
</div>
<div *ngIf="errorExist" id="alertRef" class="alert alert-danger fadein">
    <a href="#" class="close" data-dismiss="alert">&times;</a> 
    {{errorMessage}}
</div>
<div>
    <br>
</div>
<form [formGroup]="fForm" id="eappregForm" (ngSubmit)="formSubmit()">
<div class="card card-color">
    <div class="card-body p-md-4">
        
            <div class="row">
                <div class="col-md-12 text-right">
                    <label class="boldlbl"><span class="errorMsg">*</span>indicates required field.</label>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-4">
                        <label class="boldlbl"><span class="errorMsg">*</span>Business Description:</label>
                    </div>
                    <div class="col-md-7">
                        <textarea class="form-control form-control-sm" name="bus_desc" formControlName="bus_desc" (change)="convertToUpperCase('bus_desc')"
                            id="bus_desc" wrap="soft" [maxLength]="textareaCount"></textarea>
                        <div style="font-size:10px; font-style:italic">You have {{fForm.controls.bus_desc.value | remainingTextCounter:textareaCount}} characters remaining for your entry.</div>
                        <span style="color: red;"
                            *ngIf="fForm.controls.bus_desc.invalid && fForm.controls.bus_desc.touched">
                            <span *ngIf="fForm.controls.bus_desc.errors?.required">{{errorMessages.busDesReqErr}}</span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-4">
                        <label class="boldlbl"><span class="errorMsg">*</span>Legal Business Name:</label>
                    </div>
                    <div class="col-md-7">
                        <input type="text" class="form-control form-control-sm" name="busid_legal_nm"
                            formControlName="busid_legal_nm" id="busid_legal_nm" maxlength="84" [readonly]="isLegalNameReadOnly"/>
                        <span style="color: red;"
                            *ngIf="fForm.controls.busid_legal_nm.invalid && fForm.controls.busid_legal_nm.touched">
                            <span
                                *ngIf="fForm.controls.busid_legal_nm.errors?.required">{{errorMessages.busLegalNmErr}}</span>
                        </span>
                    </div>
                </div>
                <div>
                    <p>Do not use DBA (Fictitious Name) here
                    </p>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-4">
                        <label class="boldlbl">DBA (Doing Business As) Name:</label>
                    </div>
                    <div class="col-md-7">
                        <input type="text" class="form-control form-control-sm" name="busid_dba_nm"
                            formControlName="busid_dba_nm" id="busid_dba_nm" maxlength="56" [readonly]="isDBANameReadOnly"/>
                    </div>
                </div>
                <div>
                    <p>(If applicable)
                    </p>
                </div>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-4">
                        <label class="boldlbl"><span class="errorMsg">*</span>Business Start Date:</label>
                    </div>
                    <div class="col-md-4">
                        <span class="input-group">
                            <input type="text" class="form-control form-control-sm" name="busact_start_dt"
                                formControlName="busact_start_dt" id="busact_start_dt" ngbDatepicker #d1="ngbDatepicker"
                                placeholder="mm/dd/yyyy" id="asv_legalnm_dt" maxlength="10"  (ngModelChange)="loadTaxperiodGrid()" (ngModelChange)="checkGlobalGrossReceiptsCondition()" [readonly]="false" />
                                <div class="input-group-append">
                                <button class="btn btn-outline-secondary calendar fa fa-calendar"(click)="d1.toggle()" type="button"></button>
                            </div>
                            <!-- <span placement="right" ngbPopover="If your business start date is prior to the current year, Office of Finance will send you a notice requesting your gross receipts for the prior years."
                                triggers="outsideClick" #p="ngbPopover"></span> -->
                                </span>
                        <span style="color: red;"
                            *ngIf="fForm.controls.busact_start_dt.invalid && fForm.controls.busact_start_dt.touched">
                            <span *ngIf="fForm.controls.busact_start_dt.errors?.dateRequired">Please Enter Business
                                Start Date
                                (mm/dd/yyyy). It is a required field.</span>
                            <span *ngIf="fForm.controls.busact_start_dt.errors?.dateFormatErr">Please Correct Business
                                Start
                                Date. The format is (mm/dd/yyyy).</span>
                            
                            
                          <!--   <span *ngIf="fForm.controls.busact_start_dt.errors?.priorYearErr">If your business start
                                date is
                                prior to the current year, Office of Finance will send you a notice requesting your
                                gross receipts for the prior years.</span>-->
                        </span> 
                        <span style="color: red;"
                            *ngIf="issDisable===true && fForm.controls.busact_start_dt.touched">
                            
                            <span>Business Start Date must be from past 7 years to current year. Please correct.</span>
                          <!--   <span *ngIf="fForm.controls.busact_start_dt.errors?.priorYearErr">If your business start
                                date is
                                prior to the current year, Office of Finance will send you a notice requesting your
                                gross receipts for the prior years.</span>-->
                        </span>
                    </div>
                </div>
                	<p>Start date of business in the City of Los Angeles
                    </p>
                </div>
                <div>
                <div>
                    <p>(mm/dd/yyyy)
                    </p>
                </div>
            </div>
             <div class="row" >  
      <ng-container *ngIf="showTaxPeriodGrid">
                                    <div class="col-md-12 table-responsive">
                                        <div><span>Please enter your Gross Receipts on the Basis for Tax column for each Tax Period listed below.Note that for a given Tax Period, the gross receipt should be for the prior calendar year.</span></div>
                                        <table class="table table-bordered"  style="width: 100%;">
                                            <thead>
                                                <tr class="colHd1">
                                                    <th>Fund Class</th>
                                                    <th>Tax Period</th>
                                                    <th>Date From</th>
                                                    <th>Date To</th>
                                                    <th>Basis For Tax</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                 <ng-container *ngFor="let qfundClassGrid of qfundClassGridListres let i = index">
                                                 <tr>
                                                    <td>{{qfundClassGrid.revenue_type}} - {{qfundClassGrid.description}}</td>
                                                    <td>{{qfundClassGrid.taxPeriod}}</td>
                                                    <td>{{qfundClassGrid.dateFrom | date:"MM/dd/yyy"}}</td>
                                                    <td>{{qfundClassGrid.dateTo | date:"MM/dd/yyy"}}</td>
                                                    <td ><input type="text"  min="0" name="measure"    (change)="calculateTotalMeasuress(qfundClassGrid ,$event)" (change)="addMeasure(qfundClassGrid ,$event)"   
                                                    value="{{qfundClassGrid.measure}}" maxlength="10" id="measure_{{i}}"  [readonly]="qfundClassGridListres[i].isReadOnly"
                                                    	 onkeypress="return event.charCode>=48 && event.charCode <= 57"></td>
                                                   </tr>
                                                    <ng-container *ngIf="qfundClassGrid.revenue_type ==='L188' && i === dumm"><tr><td colspan="5">For information on how to calculate your Gross Receipts as a Contractor, click on this <a href="https://finance.lacity.gov/sites/g/files/wph1721/files/2021-04/L188.pdf" target="_blank">link</a> 
                                                    </td>
                                                    </tr>
                                                    </ng-container>
                                                    
                                                   </ng-container>
                                                   
                                            </tbody>
                                        </table>
                                    </div>
      </ng-container>
      <!-- INC0754669 - Enhancement - PFA EappReg - Adding GGR  -->
      <div class="form-group" *ngIf="showGlobalGrossReceipts">
    <div class="row">
        <div class="col-md-4">
            <label class="boldlbl"><span class="errorMsg">*</span>Global Gross Receipts:</label>
        </div>
        <div class="col-md-4">
       	   <input type="text" class="form-control form-control-sm" name="globalGrossReceipts" formControlName="globalGrossReceipts" id="globalGrossReceipts" maxlength="17" (change)="onGlobalGrossReceiptsChange($event)" (change)="calculateTotalMeasures()" onkeypress="return event.charCode>=48 && event.charCode <= 57"              
                formControlName="globalGrossReceipts" id="globalGrossReceipts" maxlength="17"  />
            <span style="color: red;" *ngIf="fForm.controls.globalGrossReceipts.invalid && fForm.controls.globalGrossReceipts.touched">
                <span *ngIf="fForm.controls.globalGrossReceipts.errors?.required">Global Gross Receipts is required.</span>
                <span *ngIf="fForm.controls.globalGrossReceipts.errors?.validateGgrErr">The Total Gross Receipts cannot be less than the sum of all Measures(Basis for Tax) entered.</span>  
            </span>
        </div>
    </div>
    <div>
        <p>Enter total taxable and non-taxable gross receipts from within and outside the City of Los Angeles in whole dollars for the prior year.</p>
    </div>
</div>
      
      <!-- <ng-container *ngIf="showTaxPeriodGrid && pastDate">
                                    <div class="col-md-12 table-responsive">
                                        <table class="table table-bordered"  style="width: 100%;">
                                            <thead>
                                                <tr class="colHd1">
                                                    <th>Fund Class</th>
                                                    <th>Tax Period</th>
                                                    <th>Date From</th>
                                                    <th>Date To</th>
                                                    <th>Basis For Tax</th>
                                                    <th>GGR</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                 <tr *ngFor="let qfundClassGrid of qfundClassGridListres let i = index">
                                                    <td>{{qfundClassGrid.revenue_type}} - {{qfundClassGrid.description}}</td>
                                                    <td>{{qfundClassGrid.taxPeriod}}</td>
                                                    <td>{{qfundClassGrid.dateFrom | date:"MM/dd/yyy"}}</td>
                                                    <td>{{qfundClassGrid.dateTo | date:"MM/dd/yyy"}}</td>
                                                    <td ><input type="text"  min="0" name="measure" (change)="addMeasure(qfundClassGrid ,$event)"   
                                                    value="{{qfundClassGrid.measure}}" maxlength="10" id="measure_{{i}}"  [readonly]="qfundClassGridListres[i].isReadOnly"
                                                    	 onkeypress="return event.charCode>=48 && event.charCode <= 57"></td>
                                                   	<td><input type="text"  min="0" name="payReceipt" (change)="addPayReceipt(qfundClassGrid ,$event)"
                            						 value="{{qfundClassGrid.payReceipt}}" maxlength="17" id="payReceipt_{{i}}" 
                            						 onkeypress="return event.charCode>=48 && event.charCode <= 57" />
                            </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
      </ng-container> -->
      <div></div>
      </div>    
     <!--  <div class="form-group">
               <div class="row" >
      <ng-container *ngIf="showGGR">
                    <div class="col-md-4">
                        <label class="boldlbl"><span class="errorMsg">*</span>GGR (Global Gross Receipts):</label>
                    </div>
                    <div class="col-md-4">
                        <input type="text" class="form-control form-control-sm" min="0" name="payReceipt"
                            formControlName="payReceipt" id="payReceipt" min="0" maxlength="17" onkeypress="return event.charCode>=48 && event.charCode <= 57" />
                            <span style="color: red;"
                            *ngIf="fForm.controls.payReceipt.invalid && fForm.controls.payReceipt.touched">
                            <span
                                *ngIf="fForm.controls.payReceipt.errors?.payDirectrequired">{{errorMessages.payReceiptErr}}</span>
                                </span>
                                <span style="color: red;"
                            *ngIf="fForm.controls.payReceipt.invalid && fForm.controls.payReceipt.touched">
                            <span
                                *ngIf="fForm.controls.payReceipt.errors?.payDirectrequiredErr">{{errorMessages.payDirectrequiredErr}}</span>
                        </span>
                    </div>
                    </ng-container>
                </div>
            </div> -->
                            
            <div class="form-group">
                <div class="row">
                    <div class="col-md-4">
                        <label class="boldlbl"><span class="errorMsg">*</span>Business Type:</label>
                    </div>
                    <div class="col-md-4">
                        <!-- <select id="busact_bus_type" name="busact_bus_type" formControlName="busact_bus_type" (change)="validateFEIN($event)" -->
                        <select id="busact_bus_type" name="busact_bus_type" formControlName="busact_bus_type"
                            class="form-control form-control-sm">
                            <ng-container *ngFor="let busType of miscTypes">
                                <option [value]="busType.miscType">{{busType.description}}</option>
                            </ng-container>
                        </select>
                        <span style="color: red;"
                            *ngIf="fForm.controls.busact_bus_type.invalid && fForm.controls.busact_bus_type.touched">
                            <span *ngIf="fForm.controls.busact_bus_type.errors?.businessTyperequired">Select Business Type</span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-11 offset-md-1" style="font-style: italic;">
                    <p>1.&nbsp;Sole Proprietorship - a single person operating the business</p>
                    <p>2.&nbsp;Partnership - 2 or more persons with a formal partnership agreement</p>
                    <p>3.&nbsp;Corporation/ Limited Liability Company (LLC) - The business has filed formal papers with
                        the state to become a corporation or LLC</p>
                    <p>4.&nbsp;Trust - an entity created to hold assets for the benefit of certain persons or entities
                    </p>
                </div>
            </div>
            <div class="row bg-primary p-2 form-group">
                <label class="grplabel">Primary Business Address</label>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <lib-primary-bus-address [unitTypeList]="unitTypeExcludePO" [streetTypeList]="streetTypeList"
                        [stateList]="stateList" [primaryAddressForm]="fForm"></lib-primary-bus-address>
                </div>
            </div>
            <div class="row bg-primary p-2 form-group">
                <label class="grplabel">Mailing Address</label>
            </div>
            <div class="form-check my-2">
                <input type="checkbox" class="form-check-input" name="cbSameAddr" id="cbSameAddr" formControlName="cbSameAddr"
                    (change)="selectAddr($event)">
                <label class="form-check-label boldlbl" for="cbSameAddr">Check if same as Business Address</label>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <lib-mailing-address [unitTypeList]="unitTypeList" [streetTypeList]="streetTypeList"
                        [stateList]="stateList" [mailAddressForm]="fForm"></lib-mailing-address>
                </div>
            </div>
            <div class="row bg-primary p-2 form-group">
                <label class="grplabel">Sales Tax Number</label>
            </div>
            <div class="form-group">
                <p>If you have a Sales Tax Number (Seller's Permit) enter it here.</p>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-4">
                        <label class="boldlbl">Seller's Permit Number:</label>
                    </div>
                    <div class="col-md-7">
                        <input type="text" name="busact_seller_permit" id="busact_seller_permit"
                            formControlName="busact_seller_permit" class="form-control form-control-sm"
                            maxlength="15" />
                    </div>
                </div>
            </div>
            <div class="row bg-primary p-2 form-group">
                <label class="grplabel">Business / Professional Activity Code</label>
            </div>
            <div class="form-group">
                <p>Below, enter the 6 digit Primary and 6 digit Secondary Business/Professional Activity Codes as
                    reported
                    on your Federal Tax Return. A Secondary business activity is one that comprises at least $1,000,000
                    and
                    40% of your gross receipts.
                    <!---If necessary, see the <a href="http://finance.lacity.org/sites/g/files/wph641/f/NAICSCODES.pdf" target="_blank">NAICS Code Listing</a> in pdf format to look up the codes.--->
                    Please select your NAICS Code by clicking on the Select from List link.
                </p>
            </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-md-4">
                        <label class="boldlbl"><span class="errorMsg">*</span>Primary Activity Code:</label>
                    </div>
                    <div class="col-md-3">
                        <input type="text" name="busact_irs_activity_cd" id="busact_irs_activity_cd"
                            formControlName="busact_irs_activity_cd" class="form-control form-control-sm"
                            minlength="6" maxlength="6" />
                            <span style="color: red;" *ngIf="fForm.controls.busact_irs_activity_cd.errors?.naicsValidationErr && fForm.get('busact_irs_activity_cd').touched">
                                <span>Please Correct or Remove Primary Activity code (999999 or blank).</span>
                            </span>
                            <span style="color: red;" *ngIf="fForm.controls.busact_irs_activity_cd.errors?.required && fForm.get('busact_irs_activity_cd').touched">Please select Primary NAICS(Activity) Code.</span>
                    </div>
                    <div class="col-md-4">
                        <jhi-naics-select [type]="'P'" [fc]="fc" [parentEappForm]="fForm" (pNaicsCd)="selectedPrimaryNaicsCode($event)">
                        </jhi-naics-select>
                    </div>
                </div>
            </div>
            
          <!--   <div class="form-group">
                <div class="row">
                    <div class="col-md-4">
                        <label class="boldlbl">Primary SIC Code:</label>
                    </div>
                    <div class="col-md-3">
                        <input type="text" name="busact_irs_activity_cd3" id="busact_irs_activity_cd3"
                            formControlName="busact_irs_activity_cd3" class="form-control form-control-sm"
                            minlength="1" maxlength="4"/>
                            <span style="color: red;" *ngIf="fForm.controls.busact_irs_activity_cd3.errors?.sicsValidationErr && fForm.get('busact_irs_activity_cd3').touched">
                                <span>Please Correct or Remove Primary SIC code (9999 or blank).</span>
                            </span>
                            
                    </div>
                    
                    
                </div>
            </div> -->
            
            <div class="form-group">
                <div class="row">
                    <div class="col-md-4">
                        <label class="boldlbl">Secondary Activity Code:</label>
                    </div>
                    <div class="col-md-3">
                        <input type="text" name="busact_irs_activity_cd2" id="busact_irs_activity_cd2"
                            formControlName="busact_irs_activity_cd2" class="form-control form-control-sm"
                            minlength="6" maxlength="6" />
                            <span style="color: red;" *ngIf="fForm.controls.busact_irs_activity_cd2.errors?.naicsValidationErr && fForm.get('busact_irs_activity_cd2').touched">
                                <span>Please Correct or Remove Secondary Activity code (999999 or blank).</span>
                            </span>
                    </div>
                    <div class="col-md-4">
                        <jhi-naics-select [type]="'S'" [fc]="fc" [parentEappForm]="fForm" (sNaicsCd)="selectedSecondaryNaicsCode($event)">
                        </jhi-naics-select>
                    </div>
                </div>
            </div>
            
           <!--  <div class="form-group">
                <div class="row">
                    <div class="col-md-4">
                        <label class="boldlbl">Secondary SIC Code:</label>
                    </div>
                    <div class="col-md-3">
                        <input type="text" name="busact_irs_activity_cd4" id="busact_irs_activity_cd4"
                            formControlName="busact_irs_activity_cd4" class="form-control form-control-sm"
                            minlength="1" maxlength="4"/>
                            <span style="color: red;" *ngIf="fForm.controls.busact_irs_activity_cd4.errors?.sicsValidationErr && fForm.get('busact_irs_activity_cd4').touched">
                                <span>Please Correct or Remove Secondary SIC code (9999 or blank).</span>
                            </span>
                    </div>
                    
                </div>
            </div> -->
            
            <div class="row bg-primary p-2 form-group">
                <label class="grplabel">Business Contact Information</label>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body" style="background-color: white;">
                            <lib-business-contact-info [busContactForm]="fForm"></lib-business-contact-info>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <br>
            </div>
            <div class="row bg-primary p-2 form-group">
                <label class="grplabel">Filer Information</label>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body" style="background-color: white;">
                            <lib-nested-filedby-section [filedByForm]="fForm" [extMaxlength]="4" [firstNameMaxLen]="30" [lastNameMaxLen]="30" [titleMaxLen]="20">
                            </lib-nested-filedby-section>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</div>
<div>
    <br>
</div>
<div class="text-center">
    <input type="button" class="btn btn-primary my-2" value="Back" (click)="back()"/>&nbsp;
    <button class="btn btn-primary" type="submit" >Submit</button>
</div>
<div>
    <br>
</div>
</form>